const PageState = {
    View: 0,
    Add: 1,
    Edit: 2
};

export default PageState;